/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Balance_In_CreditInputs */

const en_balance_in_credit = /** @type {(inputs: Balance_In_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`₪${i?.amount} in credit`)
};

const he_balance_in_credit = /** @type {(inputs: Balance_In_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`₪${i?.amount} בזכות`)
};

/**
* | output |
* | --- |
* | "₪{amount} in credit" |
*
* @param {Balance_In_CreditInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const balance_in_credit = /** @type {((inputs: Balance_In_CreditInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Balance_In_CreditInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_balance_in_credit(inputs)
	return he_balance_in_credit(inputs)
});